import { render, staticRenderFns } from "./NewVersionModal.vue?vue&type=template&id=5255deec&scoped=true"
import script from "./NewVersionModal.vue?vue&type=script&lang=js"
export * from "./NewVersionModal.vue?vue&type=script&lang=js"
import style0 from "./NewVersionModal.vue?vue&type=style&index=0&id=5255deec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255deec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5255deec')) {
      api.createRecord('5255deec', component.options)
    } else {
      api.reload('5255deec', component.options)
    }
    module.hot.accept("./NewVersionModal.vue?vue&type=template&id=5255deec&scoped=true", function () {
      api.rerender('5255deec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/display-builder/NewVersionModal.vue"
export default component.exports